import React, { memo } from "react"
import { getCssSizeValue, getPropSafely } from "@/utils/utils"
import styled from "styled-components"
import Text from "@/components/common/Text"
import GridContainer from "@/components/common/GridContainer"
import { useFundraisersData } from "@/components/Fundraisers"
import { BREAKPOINTS } from "@/styles/themeSettings"

const Wrapper = styled(GridContainer)`
	background-color: ${({ theme }) => theme.colors.periwinkle};
	margin: 0 calc(var(--paddingX) * -1) !important;
`

const Container = styled.div`
	display: flex;
	flex-direction: column;
	gap: 8px;
	padding: ${getCssSizeValue(32, BREAKPOINTS.MOBILE)} 0;

	@media (min-width: ${({ theme }) => theme.breakpoints.tablet}px) {
		padding: ${getCssSizeValue(32, BREAKPOINTS.TABLET)} 0;
	}

	@media (min-width: ${({ theme }) => theme.breakpoints.desktop}px) and (orientation: landscape) {
		padding: ${getCssSizeValue(32)} 0;
	}
`

function formatData(data) {
	return {
		firstName: getPropSafely(data, "firstName", ""),
		lastName: getPropSafely(data, "lastName", ""),
		identificationNumber: getPropSafely(data, "identificationNumber", ""),
		hint: getPropSafely(data, "hint", ""),
		exist: data?.exist,
	}
}

const Fundraiser = ({ data, className = "" }) => {
	const { firstName, lastName, exist, identificationNumber } = formatData(data)
	const { noResults, noResultsInfo, idNumberText } = useFundraisersData()
	return (
		<Wrapper className={`fundraiser padding ${className}`}>
			<Container className="col-mobile-8 col-tablet-7 col-desktop-14 ">
				{exist ? (
					<>
						<Text className="typo-borna-75">
							{firstName} {lastName}
						</Text>
						<Text>
							{idNumberText} <strong>{identificationNumber}</strong>
						</Text>
					</>
				) : (
					<>
						<Text className="typo-borna-75">{noResults}</Text>
						<Text>{noResultsInfo}</Text>
					</>
				)}
			</Container>
		</Wrapper>
	)
}

export default memo(Fundraiser)
